import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './BannerMyTickets.scss';

function BannerMyTickets() {
  return (
    <Container className="launchpad-banner my-tickets-banner text-white">
      <Row className="text-fs-head-xs">
        <Col>Home/My Tickets</Col>
      </Row>
      <Row className="text-fs-title-md mt-4">
        <Col lg={5} md={7}>
          MY NFT TICKETS
        </Col>
      </Row>
      <Row className="text-fs-body-md mt-4">
        <Col lg={5} md={7}>
          Track the NFT tickets currently held by your connected wallet and jump back into the
          related sales whenever you want to expand your position.
        </Col>
      </Row>
    </Container>
  );
}

export default BannerMyTickets;
